/* Keep the floating chat launcher clear of mobile product choices and facts. */
(() => {
  if (window.dopePurchaseRegionObserver || !('IntersectionObserver' in window)) return;
  const regions = new Map();
  const sync = () => document.body.toggleAttribute('data-dope-purchase-visible', [...regions.values()].some(Boolean));
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) regions.set(entry.target, entry.isIntersecting);
    sync();
  });
  const bind = () => {
    for (const region of regions.keys()) {
      if (!region.isConnected) { observer.unobserve(region); regions.delete(region); }
    }
    document.querySelectorAll('[data-dope-purchase-region]').forEach(region => {
      if (regions.has(region)) return;
      regions.set(region, false);
      observer.observe(region);
    });
    sync();
  };
  window.dopePurchaseRegionObserver = observer;
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', bind);
  bind();
})();
